// extracted by mini-css-extract-plugin
export var shapes = "newsletter-module--shapes--FlZeH";
export var deco = "newsletter-module--deco--nRdxC";
export var centered = "newsletter-module--centered--IokI5";